export const Vendor = {
  AMAZON: "amazon",
  GOOGLE: "google",
  MICROSOFT: "microsoft"
};
